import React from "react";
import { Box, Pagination } from "@mui/material";

export const ShopCenterPagination = (props) => {
  const totalPages = parseInt(props.totPages, 10) || 0;
  const currentPage = parseInt(props.currentPage, 10) || 1;

  if (totalPages <= 1) return null;

  return (
    <Box sx={{ display: "flex", justifyContent: "center", mt: 1, mb: 1 }}>
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={(_e, value) => {
          if (props.pageClicked) props.pageClicked(value);
        }}
        color="primary"
        shape="rounded"
        showFirstButton
        showLastButton
        siblingCount={1}
        boundaryCount={1}
      />
    </Box>
  );
};
